import { CellProps } from 'react-table'
import { Importacao } from '../../core/_models'
import { ImportacoesActionsCell } from './ImportacoesActionsCell'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import {
  countLabel,
  PlainHeader,
  sortableColumn,
  StackedCell,
  StatusBadge,
  TableColumn,
} from '../../../../../../components'
import { TFunction } from '_metronic/i18n/Metronici18n'

const importacoesColumns = (t: TFunction): ReadonlyArray<TableColumn<Importacao>> => [
  // Nome do arquivo como linha de apoio da descrição.
  sortableColumn<Importacao>({
    id: 'descricao',
    useQueryRequest,
    fields: [{ field: 'descricao', label: t('cols.descricao') }],
    Cell: ({ row }: CellProps<Importacao>) => <StackedCell primary={row.original.descricao} />,
  }),
  // Resultado: importados em destaque, pacientes novos como apoio.
  sortableColumn<Importacao>({
    id: 'registrosImportados',
    cellWidth: '220px',
    useQueryRequest,
    fields: [
      { field: 'registrosImportados', label: 'Importados' },
      { field: 'pacientesCadastrados', label: 'Pacientes' },
    ],
    Cell: ({ row }: CellProps<Importacao>) => (
      <StackedCell
        tabular
        primary={countLabel(row.original.registrosImportados ?? 0, {
          singular: 'registro importado',
          plural: 'registros importados',
        })}
        secondary={countLabel(row.original.pacientesCadastrados ?? 0, {
          singular: 'paciente cadastrado',
          plural: 'pacientes cadastrados',
        })}
      />
    ),
  }),
  // Erros: o rótulo carrega o significado junto com a cor.
  sortableColumn<Importacao>({
    id: 'registrosErros',
    cellWidth: '132px',
    useQueryRequest,
    fields: [{ field: 'registrosErros', label: 'Erros' }],
    Cell: ({ row }: CellProps<Importacao>) => {
      const erros = row.original.registrosErros ?? 0
      return (
        <StatusBadge
          active={erros === 0}
          labels={['Sem erros', `${erros} ${erros === 1 ? 'erro' : 'erros'}`]}
        />
      )
    },
  }),
  // Término em destaque (ordem padrão, mais recente primeiro); início como apoio. O backend
  // já manda as datas formatadas.
  sortableColumn<Importacao>({
    id: 'terminoFormatado',
    cellWidth: '200px',
    hideOnMobile: true,
    useQueryRequest,
    fields: [
      { field: 'terminoFormatado', label: 'Término' },
      { field: 'inicioFormatado', label: 'Início' },
    ],
    Cell: ({ row }: CellProps<Importacao>) => (
      <StackedCell
        tabular
        primary={row.original.terminoFormatado}
        secondary={row.original.inicioFormatado}
      />
    ),
  }),
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '132px',
    align: 'end',
    Cell: ({ row }: CellProps<Importacao>) => <ImportacoesActionsCell importacao={row.original} />,
  },
]

export { importacoesColumns }
